import { z } from "zod";

export const AdminFormsPageModals = ["create"] as const;

export default {
	adminFormsPageSchema: z.object({
		modal: z.enum(AdminFormsPageModals).optional().catch(undefined),
		search: z.string().optional().catch(""),
		relatedWorkflow: z.string().optional().catch(""),
		deleteFormId: z.string().optional().catch(""),
	}),
};
